// Module
var code = "<div class=\"bd-example\"> <middle-side :onSelectRow=\"doSelect\"/> </div>";
// Exports
export default code;